import { render, staticRenderFns } from "./ChatUserArea.vue?vue&type=template&id=6e5546db&"
import script from "./ChatUserArea.vue?vue&type=script&lang=ts&"
export * from "./ChatUserArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports